import type { RequestParams } from '../requests/http-client';
import { HttpClient } from '../requests/http-client';
import type { BaseErrorResponse, Cs2VerificatorClassVM } from './data-contracts';


export default function useVerificatorClass() {
  class VerificatorClass<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Verificator Class
     * @name VerificatorClassControllerGetVerificatorClasses
     * @summary Get verificator classes
     * @request GET:/cs2/verificator-class
     * @secure
     * @response `200` `(Cs2VerificatorClassVM)[]`
     * @response `400` `BaseErrorResponse`
     */
    verificatorClassControllerGetVerificatorClasses = (params: RequestParams = {}) =>
      this.request<Cs2VerificatorClassVM[], BaseErrorResponse>({
        path: '/cs2/verificator-class',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new VerificatorClass();
}
